//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeSheetPowTimeList', {
//        templateUrl: 'views/components/views/timeSheetPowTimeList/timeSheetPowTimeList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'timeSheetPowTimeListService', function ($stateParams, utilityService, timeSheetPowTimeListService) {
//            const vm = this;
//            let labourNo = $stateParams.labour_no;
//            let dateSelector = $stateParams.dateselector;
    		
//            vm.model = {
//                setting: {},
//                itemsListPowTimes: []
//            };
            
//            async function loadSetting() {
//                vm.model.setting = (await timeSheetPowTimeListService.getSetting({
//                    labour_no: labourNo,
//                    dateselector: dateSelector
//                }))[0];
//            }
            
//            async function loadPowTimes() {
//                if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.dateselector_index) !== true) return;
                
//                return vm.model.itemsListPowTimes = await timeSheetPowTimeListService.listPowTimes(vm.model.setting);
//            }
            
//            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
//                vm.model.setting.date_fom = startDate;
//                vm.model.setting.date_tom = endDate;
//                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

//                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) loadPowTimes();
//            }
            
//            vm.$onInit = async function () {
//                await loadSetting();
//                loadPowTimes();
//            }
//        }]
//    });
//})();
